<template>
      <v-row>
          <div style="display:flex;flex-direction:row; height: 80px;">
              <v-menu v-model="menuFrom" ref="menuFrom" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field readonly v-bind="attrs" v-on="on" prepend-icon="fa-calendar" v-model="formatDateFrom"
                          :label="$tc('changeSchedule.from')" required :rules="rules" class="ml-4"
                          style="min-width:200px; " rounded filled />
                  </template>
                  <v-date-picker locale="es-es" no-title scrollable v-model="changeDateFrom" @input="menuFrom = false">
                  </v-date-picker>
              </v-menu>
              <v-menu v-model="menuTo" ref="menuTo" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field readonly v-bind="attrs" v-on="on" prepend-icon="fa-calendar" v-model="formatDateTo"
                           :label="$tc('changeSchedule.to')"
                          style="min-width:200px;padding-right: 10px;" class="ml-5" rounded filled />
                  </template>
                  <v-date-picker locale="es-es" no-title scrollable v-model="changeDateTo" @input="menuTo = false">
                  </v-date-picker>
              </v-menu>
          </div>
      </v-row>
  </template>
    
  <script>

  import moment from "moment";
  import commons from "../../../store/workflow/commons";
  export default {
      data() {
          return {
              menuFrom: false,
              menuTo: false,
              rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
          };
      },
      props:{
        getTo:Boolean
      },
  
      computed: {
  
          // cambio la fecha y activo el dispatch
          changeDateFrom: {
              get: function () {
                  return commons.state.dateFrom
              },
              set: function (newDate) {
                  if (newDate > commons.state.dateTo) {
                      this.setDateTo(newDate)
                  }
                  this.setDate(newDate);
  
              },
          },
          changeDateTo: {
              get: function () {
                    return commons.state.dateTo
                 
              },
              set: function (date) {
                  if (date < commons.state.dateFrom) {
                      this.setDate(date)
                  }
                  this.setDateTo(date);
              },
          },
        
  
          //formateo la fecha
          formatDateFrom: {
              get() {
                  return moment(this.changeDateFrom).format("DD-MM-YYYY");
              },
              set(newValue) {
                  return moment(newValue).format("DD-MM-YYYY");
              }
  
          },
  
          formatDateTo: {
              get() {
                  if (this.changeDateTo == null) {
                      return null
                  } else {
                      return moment(this.changeDateTo).format("DD-MM-YYYY")
                  }
  
              },
              set(newValue) {
                  return moment(newValue).format("DD-MM-YYYY")
              }
  
          }
      },
      methods: {
  
          //le paso al store la fecha para que la cambie
          setDate(date) {
            commons.commit("setDateFrom", date);
          },
          setDateTo(date) {
            commons.commit("setDateTo", date);
          },
          
  
  
  
      },
  };
  </script>
    
  <style scoped>
  
  </style>